import { ApiService } from "../../../core/api-service";

const apiService = new ApiService();

const LabEquipmentApi = {
  getLabEquipment: () => apiService.get('protected/customer-equipment'),
  getManufacturerNames: () => apiService.get(`protected/customer-equipment/lab-equipment-manufactures`),
  getRobotNames: (manufacturer: string) => apiService.get(`protected/customer-equipment/lab-equipment-robots?manufacturerName=${encodeURIComponent(manufacturer)}`),
  saveEquipmentState: async (equipmentData: any) => await apiService.post('protected/customer-equipment/change-equipment-state', equipmentData),
  saveNewEquipment: (equipmentData: any) => apiService.post('protected/customer-equipment/save-new-equipment', equipmentData),
  saveNewCustomEquipment: (formData: any) => apiService.post("protected/customer-equipment/notify-equipment-change", formData)
};

export default LabEquipmentApi;